import axios from "./index";

export default {
  getVersion1() {
    return axios.get("/v1/dashboard/version1");
  },
};
